import { RhoV2Config } from './typings'

export const DefaultMainnetConfig: RhoV2Config = {
  network: 'mainnet',
  gatewayUrl: '',
  authServiceUrl: ''
}

export const DefaultTestnetConfig: RhoV2Config = {
  network: 'mainnet',
  gatewayUrl: '',
  authServiceUrl: ''
}

export const DefaultCustomConfig: RhoV2Config = {
  network: 'custom',
  gatewayUrl: 'http://localhost:8081',
  authServiceUrl: ''
}
